(function() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CONFETTI_DELAY_MS = 560;
  var DRAWER_SYNC_DELAY_MS = 180;
  var FALL_DURATION_MS = 2000;
  var MAX_Z_INDEX = 2147483647;
  var handlerAttached = false;
  var hasCartUpdateSubscription = false;
  var hasDrawerOpenSubscription = false;
  var pendingAddToCartAt = 0;
  var lastAnimationAt = 0;
  var confettiLauncher = null;
  var confettiCanvas = null;

  function isAddToCartButton(target) {
    if (!target) return false;
    var element = target.nodeType === 1 ? target : target.parentElement;
    return !!(element && element.closest && element.closest('.m-add-to-cart'));
  }

  function getConfettiLauncher() {
    if (confettiLauncher || typeof window.confetti !== 'function') return confettiLauncher;

    confettiCanvas = document.getElementById('luxury-confetti-canvas');
    if (!confettiCanvas) {
      confettiCanvas = document.createElement('canvas');
      confettiCanvas.id = 'luxury-confetti-canvas';
      confettiCanvas.setAttribute('aria-hidden', 'true');
      confettiCanvas.style.position = 'fixed';
      confettiCanvas.style.top = '0';
      confettiCanvas.style.left = '0';
      confettiCanvas.style.width = '100vw';
      confettiCanvas.style.height = '100vh';
      confettiCanvas.style.pointerEvents = 'none';
      confettiCanvas.style.zIndex = String(MAX_Z_INDEX);
      document.body.appendChild(confettiCanvas);
    }

    confettiLauncher = window.confetti.create(confettiCanvas, {
      resize: true,
      useWorker: true
    });

    return confettiLauncher;
  }

  function runLuxuryConfetti() {
    var launch = getConfettiLauncher();
    if (typeof launch !== 'function') return;

    if (typeof window.confetti !== 'function') return;

    var now = Date.now();
    if (now - lastAnimationAt < 500) return;
    lastAnimationAt = now;

    var colors = [
      '#d4af37', '#f3c96a', '#0f0f10', '#ffffff',
      '#e63946', '#2563eb', '#ec4899', '#7c3aed'
    ];
    var defaults = {
      colors: colors,
      disableForReducedMotion: true,
      zIndex: MAX_Z_INDEX
    };

    launch(
      Object.assign({}, defaults, {
        particleCount: 62,
        angle: 60,
        spread: 76,
        startVelocity: 52,
        gravity: 0.95,
        scalar: 1.05 + Math.random() * 0.25,
        origin: { x: 0.04, y: 0.72 }
      })
    );

    launch(
      Object.assign({}, defaults, {
        particleCount: 62,
        angle: 120,
        spread: 76,
        startVelocity: 52,
        gravity: 0.95,
        scalar: 1.05 + Math.random() * 0.25,
        origin: { x: 0.96, y: 0.72 }
      })
    );

    launch(
      Object.assign({}, defaults, {
        particleCount: 36,
        spread: 95,
        startVelocity: 28,
        gravity: 1.05,
        scalar: 0.95 + Math.random() * 0.2,
        origin: { x: 0.5, y: 0.34 }
      })
    );

    var endAt = now + FALL_DURATION_MS;
    var rainTimer = window.setInterval(function() {
      if (Date.now() >= endAt) {
        window.clearInterval(rainTimer);
        return;
      }
    }, 120);
  }

  function onAddToCartClick(event) {
    if (!isAddToCartButton(event.target)) return;
    pendingAddToCartAt = Date.now();
  }

  function onProductFormSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!form.querySelector('.m-add-to-cart')) return;
    pendingAddToCartAt = Date.now();
  }

  function runAfterDrawerOpen() {
    if (!pendingAddToCartAt) return;
    if (Date.now() - pendingAddToCartAt > 7000) {
      pendingAddToCartAt = 0;
      return;
    }

    var elapsed = Date.now() - pendingAddToCartAt;
    var remainingClickDelay = Math.max(0, CONFETTI_DELAY_MS - elapsed);
    var finalDelay = Math.max(DRAWER_SYNC_DELAY_MS, remainingClickDelay);
    window.setTimeout(runLuxuryConfetti, finalDelay);
    pendingAddToCartAt = 0;
  }

  function subscribeOpenCartDrawer() {
    if (hasDrawerOpenSubscription) return;
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return;
    var drawerEvent = window.MinimogTheme.pubSubEvents.openCartDrawer;
    if (!drawerEvent) return;

    window.MinimogEvents.subscribe(drawerEvent, runAfterDrawerOpen);
    hasDrawerOpenSubscription = true;
  }

  function subscribeCartUpdate() {
    if (hasCartUpdateSubscription) return;
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return;

    var cartUpdateEvent = window.MinimogTheme.pubSubEvents.cartUpdate;
    if (!cartUpdateEvent) return;

    window.MinimogEvents.subscribe(cartUpdateEvent, function(response) {
      if (!pendingAddToCartAt) return;
      if (response && response.source === 'main-cart-items') return;
      if (Date.now() - pendingAddToCartAt > 6000) return;
      if (hasDrawerOpenSubscription) return;
      window.setTimeout(runAfterDrawerOpen, DRAWER_SYNC_DELAY_MS);
    });

    hasCartUpdateSubscription = true;
  }

  function bindThemeEventsWithRetry(retriesLeft) {
    subscribeOpenCartDrawer();
    subscribeCartUpdate();

    if ((hasDrawerOpenSubscription || hasCartUpdateSubscription) || retriesLeft <= 0) return;
    window.setTimeout(function() {
      bindThemeEventsWithRetry(retriesLeft - 1);
    }, 250);
  }

  function attachListener() {
    if (handlerAttached) return;
    document.addEventListener('click', onAddToCartClick, true);
    document.addEventListener('submit', onProductFormSubmit, true);
    bindThemeEventsWithRetry(20);
    handlerAttached = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListener, { once: true });
  } else {
    attachListener();
  }

  document.addEventListener('shopify:section:load', attachListener);
})();